import QUESTION_TYPE from '@v4/constants/quiz'
import Unsupported from './Variants/Unsupported/index'
import YesNoButtons from './Variants/YesNoButtons'
import Slider from './Variants/Slider'
import Text from './Variants/Text'
import ImageButtons from './Variants/ImageButtons'
import Placeholder from './Variants/Placeholder'
import MultipleChoiceButtons from './Variants/MultipleChoiceButtons'
import RangeRadioButtons from './Variants/RangeRadioButtons'
import MultipleChoice from './Variants/MultipleChoice'
import Numeric from './Variants/Numeric'

export const TYPE_REL = Object.freeze({
	[QUESTION_TYPE.BUTTON]: YesNoButtons,
	[QUESTION_TYPE.MULTI_BUTTON]: MultipleChoiceButtons,
	[QUESTION_TYPE.MULTI_RADIO]: MultipleChoice,
	[QUESTION_TYPE.RADIO]: RangeRadioButtons,
	[QUESTION_TYPE.CHECKBOX]: MultipleChoice,
	[QUESTION_TYPE.SLIDER]: Slider,
	[QUESTION_TYPE.DIVIDED_SCALE]: RangeRadioButtons,
	[QUESTION_TYPE.TEXT]: Text,
	[QUESTION_TYPE.MULTI_IMAGE_BUTTON]: ImageButtons,
	[QUESTION_TYPE.MULTI_IMAGE_CHECKBOX]: ImageButtons,
	[QUESTION_TYPE.PLACEHOLDER]: Placeholder,
	[QUESTION_TYPE.NUMERIC]: Numeric,
	default: Unsupported,
})
export const OLD_TEXT_SIZE = Object.freeze({
	default: 1.25,
	smaller: 1,
	larger: 1.5,
})

export const TEXT_SIZE = Object.freeze({
	default: 1,
	smaller: 0.75,
	larger: 1.25,
})

export const LINE_TYPE = Object.freeze({
	multiLine: 'multi_line',
	singleLine: 'single_line',
})

export const INSTRUCTION_TEXT_POSITION = Object.freeze({
	ABOVE: 'above',
	BELOW: 'below',
})
